module.exports = require("@babel/runtime-corejs2/core-js/object/define-property");